export interface IDeferredPromise<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
  timeout?: number;
}

export class DeferredTimeoutError<T> extends Error {
  readonly deferred: IDeferredPromise<T>;

  constructor(deferred: IDeferredPromise<T>) {
    super('Operation timed out');
    this.deferred = Object.freeze(deferred);
  }
}

export function deferredPromise<T>(timeout?: number): IDeferredPromise<T> {
  const deferred: IDeferredPromise<T> = <IDeferredPromise<T>> {};

  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = (value: T | PromiseLike<T>) => {
      clearTimeout(deferred.timeout);
      resolve(value);
    };
    deferred.reject = (reason?: unknown) => {
      clearTimeout(deferred.timeout);
      reject(reason);
    };
  });

  if (timeout) {
    deferred.timeout = <number><unknown> setTimeout(() => deferred.reject(new DeferredTimeoutError(deferred)), timeout);
  }

  return deferred;
}
